import { Component, OnInit, TemplateRef, Input, OnDestroy, ElementRef } from '@angular/core';
import { BuildingService, PointService, ScoutTaskService, BuildingDoc, UserService, LookupService, PostProcessingService } from '../../core/services';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import { ShowRequest } from '../../core'
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core/app-state';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ScoutEditComponent } from './scout-edit/scout-edit.component';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { AppTab } from '../../core/app-tab';
import { UserDoc } from '../../core/schema/user-schema';
import { DatePipe } from '@angular/common';
import { StageService } from '../../core/services/stage.service';
import { StageDoc } from '../../core/schema/stage-schema';
import { BuildingStageView } from '../../core/models/building-stage-view-record';
import { TaskEditComponent } from '../../task/task-edit/task-edit.component';

@Component({
    selector: 'app-scout-list',
    templateUrl: './scout-list.component.html',
    styleUrls: ['./scout-list.component.scss']
})
export class ScoutListComponent extends FesBaseComponent implements OnDestroy {

    @Input() set tabConfig(tabConfig: AppTab) {
        tabConfig.setSelected = this.onTabSelected
    }

    @Input('detailFn') public detailFn : (vi: ShowRequest) => void;

    isLoading: boolean = false;
    scouts: ScoutTaskDoc[] = []
    buildings: BuildingDoc[] = []
    stages: StageDoc[] = []
    selectedStage: string = "1E"
    activeStage: string

    buildingStages : BuildingStageView[] = []

    constructor(
        public appState: AppState,
        private buildingService: BuildingService,
        private bsModalService: BsModalService,
        private pointService: PointService,
        private scoutService: ScoutTaskService,
        private userService: UserService,
        private stageService: StageService,
        private datePipe: DatePipe,
        public postProcessingService: PostProcessingService
    ) {
        super(appState)
        this.activeStage = appState.activeStage
    }

    async load() {
        this.isLoading = true
        try {
            const resp = await this.postProcessingService.findBuildingStages()
            this.buildingStages = resp.rows

            const scoutsRxQuery = this.scoutService.rxCollection.find()
            const scoutList = await scoutsRxQuery.exec()

            for (let i = 0; i < this.buildingStages.length; i++) {
                const building = this.buildingStages[i]
                let buildingObj = (building as any)

                const foundScout = scoutList.find(scout => {
                    return scout.get('buildingId') === building.id && scout.get('stage') === building.stage
                })
                if(foundScout) {
                    if(foundScout.assignments?.scheduleUserId) {
                        this.userService.rxCollection.findOne(foundScout.assignments.scheduleUserId).exec().then(user => {
                            if (!user) {
                                console.warn('No scheduler found for scout ' + foundScout._id + ' with userId: ' + foundScout.assignments.scheduleUserId)
                                buildingObj.scheduler = ""
                            } else {
                                buildingObj.scheduler = user.firstName + ' ' + user.lastName
                            }
                        })
                    }
                    if (foundScout.assignments?.testUserId) {
                        this.userService.rxCollection.findOne(foundScout.assignments.testUserId).exec().then(user => {
                            if (!user) {
                                console.warn('No scouter found for scout ' + foundScout._id + ' with userId: ' + foundScout.assignments.testUserId)
                                buildingObj.scouter = ""
                            } else {
                                buildingObj.scouter = user.firstName + ' ' + user.lastName
                            }
                        })
                    }
                    if (foundScout.schedule?.scheduleRequestedDate || foundScout.status?.scheduleRequested) {
                        if(foundScout.status?.scheduleRequested) {
                            buildingObj.scheduleRequested = foundScout.status.scheduleRequested.timestamp
                        }else if(foundScout.schedule?.scheduleRequestedDate) {
                            buildingObj.scheduleRequested = foundScout.schedule?.scheduleRequestedDate
                        }
                    } else {
                        buildingObj.scheduleRequested = ""
                    }
                    if (foundScout.schedule?.scheduledDate) {
                        buildingObj.scheduledDate = foundScout.schedule.scheduledDate
                    } else {
                        buildingObj.scheduledDate = ""
                    }

                    buildingObj.scout = foundScout;
                } else {
                    buildingObj.scheduler = ""
                    buildingObj.scouter = ""
                    buildingObj.scheduleRequested = ""
                    buildingObj.scheduledDate = ""
                    buildingObj.scout = null
                }
            }
        } catch (error) {
            console.error(error)
            this.postProcessingService.publishError(error,this)
        }
        this.isLoading = false
    }

    initialize() {
        this.isLoading = true;
        this.appState.doWhenReady(() => {
            this.load()
        })
    }

    onTabSelected = (bSelected: boolean) => {
        console.log('scout-list tab selected: ' + bSelected)
        if (bSelected) {
            this.initialize()
        } else {
            this.unsubscribe()
        }
    }

    ngOnDestroy(): void {
        this.destroy()
    }

    //for sorting and filtering dates in MM/dd format
    monthDayDateResolver = ( buildingObj : any, fieldName : string ) : string => {
        if ( !buildingObj ) {
            return ''
        }
        const strDate = buildingObj[fieldName]
        return this.datePipe.transform(strDate,'MM/dd')
    }

    deleteScout(scout: ScoutTaskDoc) {
        let initialState = {
            onYes: () => {
                this.scoutService.delete(scout)
                this.load()
            },
            question: scout.scoutPaths.length > 0 ? 
            `Are you sure you wish to cancel scout for ${scout.buildingId}? <br />Canceling will delete ${scout.scoutPaths.length} path(s) for this Scout!`: 
            `Are you sure you wish to cancel scout for ${scout.buildingId}?`,
            focusOnNo: true,
            yesStyle: 'btn btn-danger'
        }
        this.bsModalService.show(ConfirmModalComponent, { initialState });
    }

    scheduleScout(scout: ScoutTaskDoc) {
        this.detailFn( new ShowRequest('tab', 'schedule task', scout._id, scout) )
    }

    createScout(scout: ScoutTaskDoc){
        const initialState = {
            scout: scout,
            onYes: () => {
                this.load()
            }
        }
        this.bsModalService.show(ScoutEditComponent, { ignoreBackdropClick: true, initialState });
    }


    public editAssignedUserModal: BsModalRef
    allUsers: UserDoc[]
    selectedTask: ScoutTaskDoc
    public selectedUser: UserDoc

    editAssignedScheduler = async (template: TemplateRef<any>, task: any) => {
        this.selectedTask = task.scout
        this.isLoading = true;
        try {
            this.allUsers = await this.userService.rxCollection.find().sort({ 'firstName': 'asc', 'lastName': 'asc' }).where({"role": "scheduler"}).exec()
            this.selectedUser = this.allUsers.find(u => this.selectedTask.assignments.scheduleUserId == `${u._id}`)
        } catch (error) {
            this.userService.publishError(error, this)
            return
        } finally {
            this.isLoading = false
        }
        this.editAssignedUserModal = this.bsModalService.show(template);
    }

    editAssignedTester = async (template: TemplateRef<any>, task: any) => {
        this.selectedTask = task.scout
        this.isLoading = true;
        try {
            this.allUsers = await this.userService.rxCollection.find().sort({ 'firstName': 'asc', 'lastName': 'asc' }).where({"role": "field"}).exec()
            this.selectedUser = this.allUsers.find(u => this.selectedTask.assignments.testUserId == `${u._id}`)
        } catch (error) {
            this.userService.publishError(error, this)
            return
        } finally {
            this.isLoading = false
        }
        this.editAssignedUserModal = this.bsModalService.show(template);
    }

    async saveAssignedUser() {
        try {
            console.log(JSON.stringify(this.selectedTask.toJSON()))
            this.selectedTask.atomicUpdate( docData => {
                const userId = this.selectedUser?._id ? this.selectedUser._id : ''
                if ( !docData.assignments ) {
                    docData.assignments = {}
                }
                if(this.selectedUser?.role == "field"){
                    docData.assignments.testUserId = userId
                } else{
                    docData.assignments.scheduleUserId = userId
                }
                return docData
            })
            this.selectedTask = null;
            this.editAssignedUserModal.hide()
            this.load()
        } catch (error) {
            this.scoutService.publishError(error, this)
        } finally {
        }
    }

    editScoutTaskModal( scoutTaskDoc: ScoutTaskDoc ) {
        const initialState = {
            onSaveScoutList: () => {
                this.load()
            }
        }
        const modalRef = this.bsModalService.show(TaskEditComponent, {
          ignoreBackdropClick: true, 
          class: 'modal-lg',
          initialState
        });
        const taskEditComponent: TaskEditComponent = modalRef.content
        taskEditComponent.setTaskDoc(scoutTaskDoc)
    }

}